<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table
      :headers="headers"
      :items="app_link_super_master_list"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Mobile App Links</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on"
                >Add Link</v-btn
              >
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.link_name"
                          persistent-hint
                          hint="For example : TimeTable, HomeWork, Notice..."
                          label="Enter Link Name"
                          :rules="[(v) => !!v || 'required']"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.icon"
                          persistent-hint
                          hint="For example : mdi-account-key,mdi-content-copy"
                          label="Enter Link Icon Name"
                          :rules="[(v) => !!v || 'required']"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                          dense
                          v-model="editedItem.user_type"
                          :items="user_type_super_master_list"
                          :rules="[(v) => !!v || 'required']"
                          item-text="user_type"
                          item-value="id"
                          label="User Type"
                          hint="Select User Type : Student, Parent, Instructor"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" v-if="editedIndex != -1">
                        <v-checkbox
                          dense
                          v-model="editedItem.isactive"
                          color="success"
                          label="Active"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="primary darken-1"
                    @click="save"
                    :disabled="!valid"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon class="mr-2 v-icon-size" color="success"
            >mdi-check-circle-outline</v-icon
          >
        </span>
        <span v-else>
          <v-icon class="mr-2 v-icon-size" color="error"
            >mdi-close-circle-outline</v-icon
          >
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
              >edit</v-icon
            >
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      link_name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Link Name",
        align: "left",
        sortable: false,
        value: "link_name",
      },
      {
        text: "Icon",
        align: "left",
        sortable: false,
        value: "icon",
      },
      {
        text: "Is Active",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      {
        text: "User Type",
        align: "left",
        sortable: false,
        value: "user_type",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    app_link_super_master_list: [],
    user_type_super_master_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      link_name: "",
      icon: "",
      user_type: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      link_name: "",
      icon: "",
      user_type: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New App Link" : "Edit App Link";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.overlay = true;
      axios
        .post("/Admin/mobileAppLinksSuperMasterHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.app_link_super_master_list =
              res.data.app_link_super_master_list;
            this.user_type_super_master_list =
              res.data.user_type_super_master_list;
          } else {
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.app_link_super_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Admin/editMobileAppLinksSuperMasterHome", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.app_link_super_master_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "App Link Updated Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "App Link Already Present!"); // show snackbar on error
              } else {
                sessionStorage.setItem("error-trace", res.data.error_trace);
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        if (this.isValidated()) {
          axios
            .post("/Admin/saveMobileAppLinksSuperMasterHome", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                this.app_link_super_master_list.push(this.editedItem);
                this.showSnackbar("#4caf50", "App Link Added Successfully..."); // show snackbar on success
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "App Link Already Present!"); // show snackbar on error
              } else {
                sessionStorage.setItem("error-trace", res.data.error_trace);
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.link_name) {
        return true;
      } else {
        if (!this.editedItem.link_name) {
          this.errorMsg.link_name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>